import {Dimensions, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {darkGray, denim, onyxLightest, white} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    flexGrow: 1,
    backgroundColor: white,
    overflow: 'scroll',
  },
  container: {
    flexGrow: 1,
    marginTop: indent,
    marginBottom: indent * 1.5,
    marginHorizontal: indent * 0.7,
    lineHeight: 21,
  },
  taskTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  taskDetailTitleText: {
    marginLeft: indent * 0.6,
    fontSize: 16,
    color: codGray,
    fontWeight: '500',
  },
  strikeThroughText: {
    textDecorationLine: 'line-through',
  },
  iconContainer: {
    width: 20,
    height: 20,
    marginLeft: indent * 0.5,
  },
  selectedIcon: {
    fontSize: 20,
    color: denim,
  },
  unSelectedIcon: {
    fontSize: 20,
    borderColor: onyxLightest,
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderRadius: 2,
    color: white,
  },
  button: {
    height: 60,
    padding: 12,
    borderRadius: 8,
    backgroundColor: denim,
    width: '100%',
    marginBottom: indent,
  },
  taskDetailContent: {
    marginTop: indent * 2,
    marginBottom: indent,
    marginLeft: indent * 0.6,
  },
  preJourneyTaskDetailContent: {
    marginTop: indent * 1.2,
    marginLeft: indent * 0.6,
    marginVertical: indent * 0.5,
    paddingRight: indent * 0.5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  copyDetailContent: {
    marginTop: indent * 0.1,
    marginBottom: indent,
    marginLeft: indent * 0.6,
  },
  taskDetailsContent: {
    marginTop: indent * 2,
    marginBottom: indent,
    marginLeft: indent * 0.6,
    marginRight: indent * 0.7,
  },
  taskDetailContents: {
    marginTop: indent * 1.7,
    marginHorizontal: indent * 0.6,
    paddingRight: indent,
  },
  // @ts-expect-error TS(2322): Type '{ fontSize: number; color: string; fontFamil... Remove this comment to see the full error message
  optaTextLabel: {
    ...getFontFamily('regular'),
    fontSize: 16,
    color: codGray,
  },
  // @ts-expect-error TS(2322): Type '{ fontSize: number; color: string; fontFamil... Remove this comment to see the full error message
  optaText: {
    ...getFontFamily('bold'),
    fontSize: 16,
    color: codGray,
  },
  // @ts-expect-error TS(2322): Type '{ fontSize: number; color: string; fontFamil... Remove this comment to see the full error message
  taskDetailContentText: {
    ...getFontFamily('regular'),
    fontSize: 14,
    color: codGray,
  },
  // @ts-expect-error TS(2322): Type '{ fontSize: number; color: string; fontFamil... Remove this comment to see the full error message
  taskDetailsTextLabel: {
    ...getFontFamily('bold'),
    fontSize: 14,
    color: codGray,
  },
  taskContentText: {
    marginBottom: Dimensions.get('window').height * 0.3,
    marginHorizontal: indent * 0.6,
  },
  // @ts-expect-error TS(2322): Type '{ fontSize: number; color: string; fontFamil... Remove this comment to see the full error message
  taskDetailText: {
    ...getFontFamily('regular'),
    fontSize: 14,
    color: denim,
  },
  taskDetailListHeading: {
    marginLeft: indent * 0.4,
  },
  detailsListItemContainer: {
    marginRight: indent * 0.8,
    marginVertical: indent,
  },
  detailsListItem: {
    flexDirection: 'row',
    marginBottom: indent * 0.8,
    paddingRight: indent * 0.6,
  },
  bullet: {
    marginHorizontal: indent * 0.5,
    color: codGray,
  },
  listItem: {
    marginHorizontal: indent * 0.7,
  },
  listItemContainer: {
    marginRight: indent * 0.8,
  },
  firstWeekCelebrationContent: {
    marginRight: indent * 0.8,
  },
  dayFiveDescription: {
    marginVertical: indent,
    marginLeft: indent * 0.6,
  },
  dayFiveTaskDetailsContent: {
    marginHorizontal: indent * 1.5,
  },
  journeyKickOffCallListItem: {
    marginHorizontal: indent * 0.4,
  },
  firstWeekCelebrationListItemContainer: {
    marginTop: indent * 0.5,
    marginRight: indent * 0.8,
  },
  copyIcon: {
    fontSize: 20,
    marginRight: indent * 0.9,
    paddingLeft: indent * 3.5,
  },
  lastCheckInDateText: {
    marginLeft: indent * 0.5,
    fontSize: 12,
    color: darkGray,
    fontWeight: '400',
    marginTop: indent,
  },
  copyIconAndroid: {
    fontSize: 20,
    marginRight: indent * 0.9,
    paddingLeft: indent * 1.4,
  },
  taskDetailContentShareApp: {
    marginTop: indent * 0.6,
    ...getFontFamily('regular'),
    fontSize: 14,
    color: codGray,
  },
  shareAppTaskDetailsImage: {
    width: '132%',
    height: '100%',
  },
  shareAppTaskDetailsView: {
    position: 'relative',
    height: '100%',
    alignItems: 'center',
  },
  bottomButton: {
    marginHorizontal: indent,
    marginBottom: Dimensions.get('window').height * 0.03,
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
  },
  buttonContainer: {
    position: 'absolute',
    bottom: -10,
    width: '100%',
    backgroundColor: 'white',
    paddingVertical: indent * 3.25,
    borderTopColor: 'white',
  },
});
